import React from "react";
import { Treemap, Tooltip, ResponsiveContainer } from "recharts";
import { getL1SheetProperty } from "../../../features/reduxworkbook/WorkbookSlice";
import { useSelector } from "react-redux";
import { treeTransformData } from "../Utils/treeTransformData";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { getSheetControls } from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import useAuth from "../../../hooks/useAuth";


const getHalfTextWidth = (text, font = "16px Uber") => {
  const span = document.createElement("span");
  span.style.font = font;
  span.style.visibility = "hidden";
  span.style.whiteSpace = "nowrap";
  span.innerText = text;
  document.body.appendChild(span);
  const width = span.offsetWidth;
  document.body.removeChild(span);
  return width / 2;
};

const CustomizedContent = ({
  root,
  depth,
  x,
  y,
  width,
  height,
  value,
  index,
  nameKey,
  colors,
  isLabelVisible,
  labelFontSize,
  labelPosition,
  labelFontColor,
}) => {
  const { roles } = useAuth();
  console.log(roles);
  console.log(index);
  console.log(root);

  const text =
    (root?.children !== null && root?.children[index]?.[nameKey]) || "";
  const halfTextWidth = getHalfTextWidth(text, `${labelFontSize}px Uber`);

  // Dynamically adjust font size if text exceeds sector width
  const adjustedFontSize =
    width < halfTextWidth * 2
      ? Math.max(width / text.length, 10)
      : labelFontSize;

  // Truncate text if it exceeds sector width
  const displayText =
    width < halfTextWidth * 2
      ? text.slice(0, Math.floor(width / adjustedFontSize) - 3) + "..."
      : text;

  const getTextCoordinates = () => {
    switch (labelPosition) {
      case "top":
        return { x: x + width / 2, y: y + adjustedFontSize };
      case "bottom":
        return { x: x + width / 2, y: y + height - adjustedFontSize / 2 };
      case "left":
        return { x: x + width / 4.6, y: y + height - adjustedFontSize / 2 };
      case "right":
        return { x: x + width / 1.3, y: y + height - adjustedFontSize / 2 };
      case "center":
      default:
        return { x: x + width / 2, y: y + height / 2 };
    }
  };

  const textCoordinates = getTextCoordinates();

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          fill:
            depth < 2
              ? colors[
                  Math.floor((index / root.children?.length) * colors.length)
                ]
              : "#ffffff00",
          stroke: "#fff",
          strokeWidth: 2 / (depth + 1e-10),
          strokeOpacity: 1 / (depth + 1e-10),
        }}
      />
      {depth === 1 && isLabelVisible ? (
        <text
          x={textCoordinates.x}
          y={textCoordinates.y}
          fill={labelFontColor}
          fontSize={adjustedFontSize}
          fillOpacity={0.9}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {displayText}
        </text>
      ) : null}
    </g>
  );
};

const addTransparency = (hex, alpha) => {
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, "0");
  return `${hex}${alphaHex}`;
};

const TreeChartComp = ({
  Data,
  Sheetid,
  valueKeys,
  toolTipKeys,
  rowKeys: rawGroupByKeys,
  groupByKeys: rawRowKeys,
  subBoxKeys,
}) => {
  console.log(toolTipKeys);
  console.log(rawRowKeys);
  console.log(rawGroupByKeys);
  console.log(Data);

  const rowKeys = rawRowKeys.map((item) => item.responseKey) || [];
  const groupByKeys = rawGroupByKeys.map((item) => item.responseKey) || [];
  console.log(rawGroupByKeys);

  console.log(groupByKeys);

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const isAnimataionOff = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "isAnimataionOff" })
  );
  console.log(rowKeys);

  const transformedData = treeTransformData(
    Data,
    rowKeys[0],
    groupByKeys[0],
    valueKeys[0],
    toolTipKeys
  );
  console.log(transformedData);
  console.log(toolTipKeys);

  const {
    colorSchemeid,
    transparency,
    isLabelVisible,
    labelFontSize,
    labelPosition,
    labelFontColor,
    colorMapping,
  } = customizationObject;
  console.log(colorMapping);


  const colorScheme = getColourSchemeByID(colorSchemeid);
  console.log(transformedData);

  const COLORS = (colorScheme?.colors).map((color) =>
    addTransparency(color, transparency / 100)
  );

  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      className="flex items-center justify-center"
    >
      <Treemap
        data={transformedData}
        dataKey={valueKeys[0]?.responseKey}
        nameKey={rowKeys[0] || "name"}
        aspectRatio={4 / 3}
        content={
          <CustomizedContent
            nameKey={rowKeys[0] || "name"}
            colors={COLORS}
            isLabelVisible={isLabelVisible}
            labelFontSize={labelFontSize}
            labelPosition={labelPosition.value}
            labelFontColor={labelFontColor}
            //  formatter={(value) => formatNumber(value, SufixPrefix)}
          />
        }
        isAnimationActive={isAnimataionOff}
      >
        <Tooltip
          content={
            <CustomTooltip
              tooltipKeys={toolTipKeys}
              rowKeys={rawGroupByKeys}
              columnKeys={rawRowKeys}
              valueKeys={valueKeys}
              chartType={"tree"}
            />
          }
        />
      </Treemap>
    </ResponsiveContainer>
  );
};

export default TreeChartComp;
